import React from 'react';
import { connect } from 'react-redux';
import Header from './Header';
import Button from './Button';
import { getUserInfo } from '../reducers';
import styled from 'styled-components';
import { contactPageRoute, homePageRoute, loginRoute } from '../routes';

const SmallText = styled.p`
    font-size: 0.9rem;
    line-height: 1.5;
`;

class MessagePage extends React.Component {
    render() {
        return <React.Fragment>
        <div className={'l-wrapper l-wrapper--toggle'} id="the-body">
          <div className="l-wrapper__content pad-x">
            <Header withUserCinemaNav={false} />
  
            <div className="text-center" style={{maxWidth:'700px',margin:'0 auto'}}>
              {('vincular-ie' === this.props.match.params.page && 'invalido' === this.props.match.params.result)
                ? this.renderLinkIeInvalidContent()
                : <>
                  <h4 className="my-5 px-5" style={{margin:'5rem auto',lineHeight:'1.5em'}}>
                    {this.renderContent()}
                  </h4>
                  <Button to={homePageRoute} primary>Volver a cinemex.com</Button>
                </>
              }
            </div>
          </div>
        </div>
      </React.Fragment>;
    }

    renderContent() {
      switch (this.props.match.params.page) {
        case 'vincular-ie': return this.renderLinkIeContent();
        case 'desvincular-ie': return this.renderUnlinkIeContent();
        case 'confirmacion-email': return this.renderEmailConfirmationContent();
        case 'cambio-email': return this.props.match.params.result !== 'error' ? 'Tu correo electrónico ha sido actualizado con éxito.' : 'Ocurrió un error. Por favor inténtalo nuevamente.';
        case 'cuenta-eliminada': return 'Tu cuenta ha sido eliminada.';
      }
    }

    renderLinkIeInvalidContent() {
      return <>
        <p className="mt-5">
          El enlace de vinculación que has clickeado ya no es válido.
        </p>
        <p>
          Esto puede deberse a que ya has vinculado tu cuenta Loop con tu correo electrónico previamente.
          Si es así, sólo debes iniciar sesión para comenzar a disfrutar de tus beneficios en nuestro sitio web y aplicaciones
        </p>

        <div className='my-4'>
          {!this.props.user && <Button to={loginRoute} primary>Iniciar sesión</Button>}
          {!!this.props.user && <Button to={homePageRoute} primary>Ir a la cartelera</Button>}
        </div>

        <SmallText>
          ¿No has realizado la vinculación previamente y crees que se tratar de un error?
          Ponte en contacto cono nosotros <a href={contactPageRoute}>haciendo click aquí</a>
        </SmallText>
      </>;
    }

    renderLinkIeContent() {
      if (this.props.match.params.result !== 'error') {
        return 'Tu cuenta Cinemex Loop fue vinculada con éxito.'
      } else {
        return 'No hemos podido vincular tu cuenta Cinemex Loop. Por favor intenta nuevamente más tarde. Si el problema persiste, por favor comunícate con nosotros.'
      }
    }

    renderUnlinkIeContent() {
      if (this.props.match.params.result !== 'error') {
        return 'Tu cuenta Cinemex Loop fue desvinculada con éxito.'
      } else {
        return 'No hemos podido desvincular tu cuenta Cinemex Loop. Por favor intenta nuevamente más tarde. Si el problema persiste, por favor comunícate con nosotros.'
      }
    }

    renderEmailConfirmationContent() {
      if (this.props.match.params.result !== 'error') {
        return '¡Tu cuenta ha sido creada con éxito!'
      } else {
        return 'El enlace no es válido.'
      }
    }
}

const mapStateToProps = (state) => ({
  user: getUserInfo(state),
});

export default connect(
  mapStateToProps
)(MessagePage);